import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QuestionBase} from '../components/general/question/question-base';
import { SuperuserServiceModule } from '../superuser-service.module';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class QuestionControlService {
  constructor() {
  }

  /**
   * Creates a FormGroup from QuestionBase array.
   * @param questions The QuestionBase objects used to create the FormGroup.
   */
  toFormGroup(questions: QuestionBase<any>[]): FormGroup {
    const group: any = {};

    questions.forEach(question => {
      const validators: any[] = [];
      if (!!question.required) {
        validators.push(Validators.required);
      }
      const formControl: FormControl = new FormControl(question.value || '', validators);
      if (!!question.readOnly) {
        formControl.disable();
      }
      group[question.key] = formControl;
    });
    return new FormGroup(group);
  }
}
